/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Definition_BadgeInputs */

const en_landing_definition_badge = /** @type {(inputs: Landing_Definition_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is Alchema`)
};

const de_landing_definition_badge = /** @type {(inputs: Landing_Definition_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist Alchema`)
};

const fr_landing_definition_badge = /** @type {(inputs: Landing_Definition_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce qu'Alchema`)
};

const es_landing_definition_badge = /** @type {(inputs: Landing_Definition_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que es Alchema`)
};

const it_landing_definition_badge = /** @type {(inputs: Landing_Definition_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cos'e Alchema`)
};

const nl_landing_definition_badge = /** @type {(inputs: Landing_Definition_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is Alchema`)
};

const pl_landing_definition_badge = /** @type {(inputs: Landing_Definition_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czym jest Alchema`)
};

const fi_landing_definition_badge = /** @type {(inputs: Landing_Definition_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mika on Alchema`)
};

const da_landing_definition_badge = /** @type {(inputs: Landing_Definition_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvad er Alchema`)
};

const sv_landing_definition_badge = /** @type {(inputs: Landing_Definition_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vad aer Alchema`)
};

/**
* | output |
* | --- |
* | "What is Alchema" |
*
* @param {Landing_Definition_BadgeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_definition_badge = /** @type {((inputs?: Landing_Definition_BadgeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Definition_BadgeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_definition_badge(inputs)
	if (locale === "fr") return fr_landing_definition_badge(inputs)
	if (locale === "es") return es_landing_definition_badge(inputs)
	if (locale === "it") return it_landing_definition_badge(inputs)
	if (locale === "nl") return nl_landing_definition_badge(inputs)
	if (locale === "pl") return pl_landing_definition_badge(inputs)
	if (locale === "fi") return fi_landing_definition_badge(inputs)
	if (locale === "da") return da_landing_definition_badge(inputs)
	if (locale === "sv") return sv_landing_definition_badge(inputs)
	return en_landing_definition_badge(inputs)
});